const AddedTagList = (props) => {
  const tagList = props.TagList ? props.TagList.filter(Boolean) : [];

  return (
    <div className="event-create-tags-list-wrap">
      <p className="event-create-tag-count">{tagList.length} Tags.</p>
      {tagList.length > 0 && (
        <div className="event-create-tag-list" aria-live="polite">
          {tagList.map((tag, index) => (
            <span className="event-create-tag-chip" key={`${tag}-${index}`}>
              {tag}
              <button
                type="button"
                className="event-create-tag-remove"
                aria-label={`Remove ${tag}`}
                disabled={props.isLoading}
                onClick={() => props.TagHandler(tag)}
              >
                &times;
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddedTagList;
